export const USER_TYPE = 'user';
export const CANVASSER_TYPE = 'canvasser';
